import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { pricingData } from '../data/pricingData';
export function PastQuotes({
  userEmail,
  priceType,
  autoSelectQuoteId,
  onQuoteSelected
}) {
  const [quotes, setQuotes] = useState([]);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const quoteRefs = useRef({});
  useEffect(() => {
    loadQuotes();
  }, [userEmail]);
  useEffect(() => {
    if (autoSelectQuoteId && quotes.length > 0) {
      const quoteIndex = quotes.findIndex(q => q.id === autoSelectQuoteId);
      if (quoteIndex !== -1) {
        setSelectedQuote(quoteIndex);
        setTimeout(() => {
          const quoteElement = quoteRefs.current[quoteIndex];
          if (quoteElement) {
            quoteElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
          if (onQuoteSelected) {
            onQuoteSelected();
          }
        }, 100);
      }
    }
  }, [autoSelectQuoteId, quotes]);
  const loadQuotes = () => {
    const savedQuotes = localStorage.getItem('my_quotes');
    if (savedQuotes) {
      const quotes = JSON.parse(savedQuotes);
      setQuotes(quotes.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const formatCurrency = amount => {
    return `$${parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };
  return <div className="bg-white rounded-lg shadow-xl p-6" data-id="element-114" data-mp="12sb3dfa8lo7k">
      <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-115" data-mp="12pf8y0xllhnv">Past Quotes</h2>
      {quotes.length === 0 ? <div className="text-center py-12 text-gray-500" data-id="element-116" data-mp="xu9oz7nrad2f">
          <p className="text-lg" data-id="element-117" data-mp="sunayw03sssk">No past quotes found</p>
          <p className="text-sm mt-2" data-id="element-118" data-mp="j5zrt7bw80ty">Submit a quote to see it appear here</p>
        </div> : <div className="space-y-4" data-id="element-119" data-mp="o5ce9qyur5w0">
          {quotes.map((quote, index) => <div key={index} ref={el => quoteRefs.current[index] = el} className={`border rounded-lg p-4 transition-shadow ${selectedQuote === index ? 'border-blue-500 border-2' : 'border-gray-200'}`} data-id="element-120" data-mp="97k1v7olqxm1" data-mpi={index}>
              <div className="flex justify-between items-center" data-id="element-121" data-mp="11wpvuzd79toe">
                <div data-id="element-122" data-mp="16vkeo1b63i8i">
                  <p className="font-semibold text-gray-800" data-id="element-123" data-mp="16tzlaf0la5c8">
                    Quote #{quotes.length - index}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-124" data-mp="s4k4nrurvga9">
                    {formatDate(quote.date)}
                  </p>
                </div>
                <div className="flex items-center gap-4" data-id="element-125" data-mp="1kutw14b40ie2">
                  <div className="text-right" data-id="element-126" data-mp="1kt913dkvuxfo">
                    <p className="text-xl font-bold text-blue-600" data-id="element-127" data-mp="1pmtwqyz07fbp">
                      {formatCurrency(quote.total)}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-128" data-mp="3a9uq75tjydub">
                      {Object.keys(quote.cart).length} item(s)
                    </p>
                  </div>
                  <button onClick={() => setSelectedQuote(selectedQuote === index ? null : index)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label={selectedQuote === index ? 'Collapse quote details' : 'Expand quote details'} data-id="element-129" data-mp="3k1hb5tvozra9">
                    <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${selectedQuote === index ? 'rotate-180' : ''}`} data-id="element-130" data-mp="2wc6h0v8ukv53" />
                  </button>
                </div>
              </div>
              {selectedQuote === index && <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-131" data-mp="16xfafikoyaxp">
                  <h3 className="font-semibold text-gray-800 mb-3" data-id="element-132" data-mp="1axpcik5d4h7a">
                    Quote Details
                  </h3>
                  <div className="mb-4" data-id="element-133" data-mp="1fw0nwzbb2zrm">
                    <h4 className="font-medium text-gray-700 mb-2" data-id="element-134" data-mp="1fz4zihr3oxsb">
                      Customer Information
                    </h4>
                    <div className="text-sm text-gray-600 space-y-1" data-id="element-135" data-mp="1pvrjl4blrkta">
                      <p data-id="element-136" data-mp="1ptf3kwpenkiv">
                        <span className="font-medium" data-id="element-137" data-mp="1twbfy5ocqked">Name:</span>{' '}
                        {quote.customer.name}
                      </p>
                      <p data-id="element-138" data-mp="1yo3a0q6pv899">
                        <span className="font-medium" data-id="element-139" data-mp="1ypw4l742220w">Email:</span>{' '}
                        {quote.customer.email}
                      </p>
                      <p data-id="element-140" data-mp="28mir00c15151">
                        <span className="font-medium" data-id="element-141" data-mp="28namzc9jh0vu">Phone:</span>{' '}
                        {quote.customer.phone}
                      </p>
                      <p data-id="element-142" data-mp="1xgx9q3oczwm">
                        <span className="font-medium" data-id="element-143" data-mp="1xqqdmk0nn6j">State:</span>{' '}
                        {quote.customer.state}
                      </p>
                      {quote.customer.address && <p data-id="element-144" data-mp="3o3vsdhgffz5r">
                          <span className="font-medium" data-id="element-145" data-mp="3o574c4k10d7y">Address:</span>{' '}
                          {quote.customer.address}
                        </p>}
                      {quote.customer.city && <p data-id="element-146" data-mp="kpt1yjhswd9x">
                          <span className="font-medium" data-id="element-147" data-mp="foc28rb1ywux">City:</span>{' '}
                          {quote.customer.city}
                        </p>}
                      {quote.customer.zip && <p data-id="element-148" data-mp="5y0yp5va6pok">
                          <span className="font-medium" data-id="element-149" data-mp="5ysizkjfh0zj">ZIP:</span>{' '}
                          {quote.customer.zip}
                        </p>}
                    </div>
                  </div>
                  <div data-id="element-150" data-mp="ylwrw0ln5zgl">
                    <h4 className="font-medium text-gray-700 mb-2" data-id="element-151" data-mp="2svtq60mli8qb">Items</h4>
                    <div className="space-y-2" data-id="element-152" data-mp="2sxxx6rfsjnut">
                      {Object.entries(quote.cart).map(([itemId, quantity]) => {
                const item = pricingData.find(p => p.id === itemId);
                if (!item) return null;
                const unitPrice = item[priceType];
                const subtotal = unitPrice * quantity;
                return <div key={itemId} className="flex justify-between text-sm" data-id="element-153" data-mp="2e6p76h7z80h5">
                            <span className="text-gray-700 flex-1" data-id="element-154" data-mp="208r07wvzj6bo">
                              {item.name}
                            </span>
                            <span className="text-gray-600 mx-4" data-id="element-155" data-mp="3ukfhw6tlpmzr">
                              {formatCurrency(unitPrice)} × {quantity}
                            </span>
                            <span className="font-medium text-gray-800 min-w-[80px] text-right" data-id="element-156" data-mp="3c9vwwdbku4c">
                              {formatCurrency(subtotal)}
                            </span>
                          </div>;
              })}
                      <div className="pt-2 border-t border-gray-200 flex justify-between font-bold" data-id="element-157" data-mp="1xo1a1waou5ba">
                        <span data-id="element-158" data-mp="1sugm6x2t6rpt">Total</span>
                        <span className="text-blue-600" data-id="element-159" data-mp="26mwh1alk3jfn">
                          {formatCurrency(quote.total)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>)}
        </div>}
    </div>;
}